import { useContext, useState } from 'react';
import './style.css'
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import isNotNullOrEmpty from '../../../../utils/isNotNullOrEmpty';
import { CadastroContext } from '../../../../contexts/CadastroContext';

const AsoFuncaoEmpresa = () => {
    const [options] = useState(['Administrador(a)', 'Acionista', 'Beneficiário(a) final', 'Mandatário(a)', 'Representante legal', 'Procurador(a)']);
    const [selectedOption, setSelectedOption] = useState(0);
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const navigate = useNavigate();

    const handleButtonClick = (index: number) => {
        setSelectedOption(index);
        cadastro.funcaoEmpresa = options[index];
        handleCadastroChange(cadastro);
    }

    const handleContinuar = () => {
        if (isNotNullOrEmpty(cadastro.funcaoEmpresa)) {
            navigate("/aso/registro/validar-documentos-empresa");
        }
    }

    return (
        <div className="aso-funcao-empresa-body">
            <div className="aso-empresa-funcao-container">
                <div className='aso-funcao-empresa-title'>Qual é sua principal função na empresa?</div>
                <div className="aso-funcao-empresa-subtitle">Observe que você deve ter um documento legal que te autorize a atuar em nome da empresa.</div>
            </div>
            <div className='aso-empresa-funcao-container'>
                <div className='aso-empresa-funcao-listar-opcoes-container'>
                    {options.map((option, index) => (
                        <Button key={index} className='aso-empresa-funcao-botao' onClick={() => handleButtonClick(index)}>
                            <div className='aso-empresa-funcao-botao-texto'>
                                {option}
                            </div>
                            <div className='aso-empresa-funcao-radio-wrapper'>
                                <input type="radio" className='aso-empresa-funcao-radio-button' checked={selectedOption === index} readOnly/>
                            </div>
                        </Button>
                    ))}
                </div>
                <div className='aso-empresa-funcao-continuar-button-container-mobile'>
                    <div className='aso-empresa-funcao-continuar-button-container'>
                        <Button className='aso-empresa-funcao-continuar-button' onClick={() => navigate('/aso/registro/empresa-beneficiarios-finais')}>
                            Voltar
                        </Button>
                        <Button className='aso-empresa-funcao-continuar-button' disabled={selectedOption === null} onClick={handleContinuar}>
                            Continuar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AsoFuncaoEmpresa;